export default `
§ uiKit.console.button: Copiar
§ uiKit.console.notification: El texto ha sido copiado
§ uiKit.dataLoader.page: Página
§ uiKit.dataLoader.size: Mostrando hasta
§ uiKit.dataLoader.rows: lines.
§ uiKit.dataLoader.from: de
§ uiKit.dataLoader.all: Mostrar todo
§ uiKit.hoursChart.work: horario laboral normal (lunes a viernes, de 07:00 a 20:00)
§ uiKit.hoursChart.weekend: días o horario antes/después del día laboral
§ uiKit.hoursChart.days: número total de commits en un día y una hora específica
§ uiKit.page.remove: Eliminar
§ uiKit.nothingFound.common.title: No hay o no hay suficientes datos para mostrar
§ uiKit.nothingFound.common.description: El sistema procesará más datos si los commits se firman con el formato de [Git commit message convention|https://www.conventionalcommits.org/en/v1.0.0/]. Patrón:
§ uiKit.nothingFound.common.console: Número_de_tarea tipo(característica): descripción
§ uiKit.nothingFound.common.example: Por ejemplo:
§ uiKit.nothingFound.personal.title: No hay datos para este colaborador
§ uiKit.nothingFound.personal.description1:
El no hizo cambios todos los días laborables y obtuvo el estado “Asistente”.
El trabajo de los colaboradores con este estatus en este proyecto puede desestimarse, ya que su aporte en el conjunto es insignificante.

§ uiKit.nothingFound.staff.description2
Поэтому система не рассчитывает для него ряд показателей.
Если это ошибка и данного сотрудника нужно рассчитать как обычного, перейдите в раздел «Настройки» и измените его тип.

§ common.title: Estadísticas git
§ common.filters: Filtros
§ common.notifications.save: Cambios guardados
§ common.notifications.setting: Ajustes guardados
§ common.fileLoader.notification: Cant open file $1
`;
